export default {
  parameters: {
    landing_id: "ItAbFreeTC",
  },
  newDesign: true,
  title: "Ricevi una lezione gratuita su Kodland",
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    startBackground: "white",
    quizBackground: "#white",
    title:
      "Lezioni di programmazione per bambini dai 5 ai 17 anni",
    subtitle:
      "I bambini creeranno il loro primo gioco dopo solo una lezione! Le lezioni saranno in italiano!",
    image: {
      url: "/welcome/freetc_italy_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/freetc_italy_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Prenota una lezione gratuita ",
  },
  // successPage: {
  //   title: "¡Felicitaciones! 🎁",
  //   subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
  //   button: "📆 Reservar una clase",
  // },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Grazie per aver scelto la nostra piattaforma educativa!",
    subtitle:
      "Sfortunatamente, tablet o telefoni non sono adatti per seguire le nostre lezioni. Saremo felici di vedervi nelle nostre lezioni la prossima volta!",
  },
  quizRotateBySteps: {
    1: {
      question: "Come trascorre il tempo libero tuo figlio/a?",
      answers: [
        "Fa delle attività artistiche: disegno, musica, recitazione 🎨",
        "Gioca con il cellulare o il computer 🎮",
        "Gioca a giochi da tavolo 👍",
        "Fa sport 🏅",
        "Trascorre del tempo con la famiglia 👨‍👩‍👦",
        "Guarda i cartoni animati 🦹‍♀️",
        "Esce con gli amici 🧑‍🤝‍🧑"
      ],
    },
    2: {
      question: "Perché ti interessa l'idea di una lezione di programmazione per tuo figlio/a?",
      answers: [
        "Il bambino gioca molto 🎮",
        "Il bambino è 'dipendente' da YouTube e TikTok 😜",
        "Il bambino ha un interesse per la programmazione 👾",
        "Altro ❓",
      ],
    },
    3: {
      title: "Quanti anni ha tuo figlio/a?",
      type: "age",
      button: "",
    },
    4: {
      question:
        "Hai un computer/portatile per studiare? ",
      answers: [
        "Sì ✔️",
        {
          answer: "No ❌",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "Congratulazioni! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Clicca su '📆 Prenota una lezione' per completare la registrazione",
      button: "📆 Prenota una lezione",
    },
    6: {
      title: "Prenota una lezione gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "👏 Perfetto. Manca l'ultimo passaggio!",
    },
    7: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    8: {
      title:
        "Controlla questi dettagli per completare la registrazione ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ti ricordiamo che per la lezione avrai bisogno di un PC o laptop funzionante e che dovrai accompagnare tuo figlio per tutta la lezione. Ricorda che è individuale e personalizzato.",
      button: "Cos'altro?",
    },
    9: {
      title: "Controlla la tua email e WhatsApp prima della lezione di prova 📞",
      typeInfo: "whatsapp",
      subtitle:
        "24 ore prima della lezione ti invieremo un promemoria e 2 ore prima della lezione ti chiederemo di confermare la tua presenza. È molto importante rimanere in contatto affinché la lezione non venga annullata.",
      button: "Cos'altro?",
    },
    10: {
      title: "La lezione si svolgerà sulla nostra piattaforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Riceverai un link e un codice univoco via WhatsApp ed email. Basta cliccare sul link, ti porterà direttamente alla lezione. Senza app aggiuntive e senza download.",
      button: "Ho capito ✅",
    }
  },
};
